class AppVisibility {
  private _isFocused: boolean = true;

  constructor() {
    const handleOnIsFocused = () => {
      this._isFocused = true;
    };

    const handleOnIsPause = () => {
      this._isFocused = false;
    };

    if (typeof window !== 'undefined') {
      document.addEventListener('resume', handleOnIsFocused);
      document.addEventListener('pause', handleOnIsPause);
    }
  }

  get isFocused() {
    return this._isFocused;
  }

  callOnResumed(callback: Function) {
    if (typeof window !== 'undefined') {
      document.addEventListener('resume', () => callback(), { once: true });
    }
  }
}

export default new AppVisibility();
